// extracted by mini-css-extract-plugin
export default {"welcome_placeholder":"WelcomeMessage_welcome_placeholder__tU0dl","logo_normal":"WelcomeMessage_logo_normal__yv0QX"};